import ApiService from "./apiservice";

export const PermissionService = {
    getPermission(_auth) {
        const params = new URLSearchParams();
        params.append('perno', _auth.username);

        return ApiService.get("GetPermissionList", params);
    },
    GetAdminPermissionList() {
        return ApiService.get("permission/GetAdminPermissionList");
    },
    GetPersonelPermissionList() {
        return ApiService.get("permission/GetPersonelPermissionList");
    },
    UpdatePermission(data) {
        return ApiService.post("permission/UpdatePermission",data);
    },
    UpdateDefaultPermission(data) {
        return ApiService.post("permission/UpdateDefaultPermission",data);
    },
    ResetPersonsDedicatedPermission(data) {
        return ApiService.post("permission/ResetPersonsDedicatedPermission",data);
    },
    UpdateSectionsPersonPermission(data) {
        return ApiService.post("permission/UpdateSectionsPersonPermission",data);
    },
    getSectionPermissions(params) {
        return ApiService.get("permission/getSectionPermissions",params);
    },
};